<!-- ###################  ADD frontline mi2 Header Dates  ################### -->
<div
    *ngIf="tempFlMI2Data?.userId != null"
    class="cmps-mi2-main--bar"
>
    <div class="cmps-mi2-main--bar-dates pb-3">
        <div>
            <span>Current Period:</span
            ><span class="ml-1"
                >{{ FLMi2PeriodDates?.startDate | cmpsDate: 'MMM d, y' }} -
                {{ FLMi2PeriodDates?.endDate | cmpsDate: 'MMM d, y' }}
            </span>
        </div>
        <div>
            <span>Previous Period:</span
            ><span class="ml-1"
                >{{
                    FLMi2PeriodDates?.previousStartDate | cmpsDate: 'MMM d, y'
                }}
                -
                {{ FLMi2PeriodDates?.previousEndDate | cmpsDate: 'MMM d, y' }}
            </span>
        </div>
        <div>
            <span>Last Update:</span
            ><span class="ml-1"
                >{{ FLMi2PeriodDates?.createdOn | cmpsDate: 'MMM d, y' }},
                {{ FLMi2PeriodDates?.createdOn | cmpsDate: 'h:mm a' }}</span
            >
        </div>
    </div>
</div>
<!-- ###################  ADD frontline mi2 grid div  ################### -->
<div>
    <div
        class="container-fluid"
        style="text-align: left"
    >
        <div class="badge-legend nogutter mb-2">
            <div class="utilities-buttons"></div>
        </div>
        <ng-container *ngIf="tempFlMI2Data?.userId == null">
            <div class="table-coaching-insight-content-sec">
                <div class="text-center">
                    {{ i18n._11156_NO_FRONT_LINE_MI2_DATA___ | translate }}
                </div>
            </div>
        </ng-container>
        <div
            *ngIf="tempFlMI2Data?.userId != null"
            class="table-coaching-insight-content-sec"
        >
            <!-- ###################  ADD frontline mi2 grid div  ################### -->
            <table
                stickyTableContainer
                class="table coaching-insight-content"
                [ngClass]="{
                    'more-metrics-opened':
                        moreOAMetricsOpened === true ||
                        moreNonOAMetricsOpened === true
                }"
                *ngIf="columns | async as cols"
            >
                <colgroup>
                    <ng-container *ngFor="let th of cols; let i = index">
                        <col
                            [ngStyle]="th.colstyle"
                            [ngClass]="th.colclass"
                            *ngIf="th.active == true"
                        />
                    </ng-container>
                </colgroup>

                <thead>
                    <tr
                        #thConatiner
                        stickyTableHeaderRow
                    >
                        <ng-container *ngFor="let th of cols; let i = index">
                            <th
                                stickyTableHeader
                                [ngStyle]="th.styles"
                                class="team-floa-header"
                                [ngClass]="th.class"
                                *ngIf="th.active == true"
                            >
                                <div
                                    class="floa-header"
                                    [ngbTooltip]="
                                        i == 3 ? mi2_data_tooltip : ''
                                    "
                                    tooltipClass="oa-widget-tooltip"
                                >
                                    <div
                                        *ngIf="th.left"
                                        [ngClass]="th.left.class"
                                        [innerHTML]="th.left.content"
                                    ></div>

                                    <div
                                        class="team-oa-header-item"
                                        [ngClass]="th.classes"
                                    >
                                        <div
                                            class="header-content"
                                            [ngClass]="th.headerContentClass"
                                            [innerHTML]="th.header"
                                        ></div>

                                        <ng-container
                                            *ngFor="let icon of th.icon"
                                        >
                                            <div
                                                class="team-oa-header-icon-container"
                                            >
                                                <cmps-icon
                                                    class="cmps-cdk-cursor-pointer"
                                                    [svgIcon]="
                                                        icon.class[icon.counter]
                                                    "
                                                    (click)="
                                                        toggle(
                                                            $event,
                                                            icon,
                                                            cols
                                                        )
                                                    "
                                                    *ngIf="
                                                        icon &&
                                                        icon.state !== undefined
                                                    "
                                                ></cmps-icon>
                                            </div>
                                        </ng-container>
                                    </div>

                                    <div
                                        *ngIf="th.right"
                                        [ngClass]="th.right.class"
                                        [innerHTML]="th.right.content"
                                    ></div>
                                </div>
                            </th>
                        </ng-container>
                    </tr>
                </thead>

                <tbody class="coaching-insight-metrics-sec">
                    <!-- New -->
                    <ng-container *ngIf="tempFlMI2Data">
                        <ng-content
                            *ngTemplateOutlet="
                                frontlineRowHierarchy;
                                context: {
                                    rowdata: getFlMI2Data(1, tempFlMI2Data)
                                }
                            "
                        ></ng-content>
                    </ng-container>
                    <!-- templates -->

                    <ng-template
                        #frontlineRowHierarchy
                        let-rowdata="rowdata"
                    >
                        <tr
                            frontmi2linePersonRow
                            [periodTypeId]="periodTypeId"
                            [periodTypeDate]="periodTypeDate"
                            [ngClass]="rowdata.levelClass"
                            [flmi2Person]="rowdata"
                            [maxUncoached]="rowdata.maxUncoached"
                            [maxCoached]="rowdata.maxCoached"
                            [mi2popup]="mi2popup"
                            (selectedUserChange)="
                                selectedUserChange.emit($event)
                            "
                            (collapsed)="checkIfAllCollapsed()"
                            (receivedSubordinates)="
                                appendSubordinates($event, rowdata)
                            "
                            (receivedMetrics)="appendMetrics($event, rowdata)"
                        ></tr>

                        <ng-container
                            *ngIf="rowdata.subOrdinates && rowdata.isExpanded"
                        >
                            <ng-container
                                *ngFor="let subdata of rowdata.subOrdinates"
                            >
                                <ng-content
                                    *ngTemplateOutlet="
                                        frontlineRowHierarchy;
                                        context: {
                                            rowdata: getFlMI2Data(
                                                rowdata.level + 1,
                                                subdata
                                            )
                                        }
                                    "
                                ></ng-content>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #nosubordinate>
    <td
        class="no-floa-subordinates"
        [colSpan]="(columns | async).length"
    >
        <div>{{ i18n._11157_NO_TEAM___ | translate }}</div>
    </td>
</ng-template>

<ng-template #mi2_data_tooltip>
    <div class="mi2-data-tooltip-box">
        <ng-container *ngFor="let cat of flmi2Data?.flMi2Details">
            <ng-container *ngFor="let grp of cat?.mi2ImproveGroupCategories">
                <div class="mi2-data-tooltip-box-repeat">
                    <p>
                        <span
                            [style.background-color]="grp?.colour"
                            class="mi2-data-tooltip-box-cmps-icon"
                            ><cmps-icon svgIcon="account"></cmps-icon></span
                        ><span
                            class="mi2-data-tooltip-box-repeat--text-label"
                            >{{ grp?.scorecardImprovementGroupName }}</span
                        >
                    </p>
                </div>
            </ng-container>
            <hr />
        </ng-container>
    </div>
</ng-template>
